/**
 * This mixin should be used when you want quick access to the peer node id by giving one of its
 * other property. This mixin assumes that you are also mixing in the _PeerModelListenerMixin.
 * Although, Peer Model provides a method "getByProperty" that is very computationally intensive
 * since it has to search through the entire tree to find the matching peer node. This mixin strives
 * to solve this performance problem by maintaining a map between a given property and the
 * corresponding peer node id. For example, if you want to store a property in your peer node called
 * "tag" and would want to find a peer node with a tag "foo", then you would set the
 * _propertyToIndex in your constructor to "tag" and then use the _getPeerNodeIdForProperty method.
 */

define([
    "dojo/_base/declare",
    "dojo/_base/lang",
    "dojo/aspect"
], function (declare, lang, aspect) {
    return declare([], {

        constructor: function () {
            // The key is the value of the propertyToIndex and the value is the id of the
            // corresponding peer node
            this._propertyIndexMap = {};

            // Add to the index every time a new peer node is added.
            aspect.before(this, "onChildAdd", lang.hitch(this, function (event) {
                var propertyValue = event.data.child.getProperty(this._propertyToIndex);
                if (propertyValue) {
                    this._propertyIndexMap[propertyValue] = event.data.child.getId();
                }
            }));

            // Update the index every time the indexed property's value is changed
            aspect.before(this, "onPropertySet", lang.hitch(this, function (event) {
                if (event.data.key === this._propertyToIndex && event.data.newValue) {
                    this._propertyIndexMap[event.data.newValue] = event.target.getId();
                }
            }));

            // Remove the corresponding entry from the index when the peer node is destroyed
            aspect.before(this, "onChildDestroy", lang.hitch(this, function (event) {
                delete this._propertyIndexMap[event.data.child.getProperty(this._propertyToIndex)];
            }));
        },

        /**
         * This method can be used to retrieve the id of the peer node corresponding to the given
         * property value of the indexed property.
         * @param propertyValue
         * @returns peerNodeId
         */
        _getPeerNodeIdForIndexedProperty: function (propertyValue) {
            return this._propertyIndexMap[propertyValue];
        }
    });
});

